import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { useComponentTheme } from '@chegg-ui/theme';
import { getThemeConfig } from '@chegg-ui/input';
import { InputWrapper } from '@chegg-ui/input-wrapper';
import { BasicStyledTextarea } from '../styles';
var Textarea = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var inputId = props.inputId,
      errorText = props.errorText,
      className = props.className,
      labelText = props.labelText,
      visuallyHideLabel = props.visuallyHideLabel,
      helperText = props.helperText,
      width = props.width,
      adjustToBackgroundColor = props.adjustToBackgroundColor,
      givenOnChange = props.onChange,
      dataTest = props['data-test'],
      theme = props.theme,
      remainingInputProps = _objectWithoutProperties(props, ["inputId", "errorText", "className", "labelText", "visuallyHideLabel", "helperText", "width", "adjustToBackgroundColor", "onChange", "data-test", "theme"]);

  var themeConfig = getThemeConfig(theme === null || theme === void 0 ? void 0 : theme.input);
  var inputComponentTheme = useComponentTheme({
    name: 'Input',
    theme: _objectSpread(_objectSpread({}, themeConfig), {}, {
      "default": function _default(theme) {
        return _objectSpread(_objectSpread({}, themeConfig["default"](theme)), {}, {
          activeBoxShadow: "0 0 0 1px ".concat(theme.colors.border.dark900),
          errorBoxShadow: "0 0 0 1px ".concat(theme.colors.error.dark)
        });
      }
    })
  });
  return /*#__PURE__*/React.createElement(InputWrapper, {
    inputId: inputId,
    className: className,
    labelText: labelText,
    visuallyHideLabel: visuallyHideLabel,
    errorText: errorText,
    helperText: helperText,
    width: width,
    adjustToBackgroundColor: adjustToBackgroundColor,
    "data-test": dataTest
  }, /*#__PURE__*/React.createElement(BasicStyledTextarea, _extends({}, remainingInputProps, {
    id: inputId,
    ref: ref,
    onChange: function onChange(e) {
      return givenOnChange(e.target.value);
    },
    "data-test": dataTest || inputId,
    customTheme: inputComponentTheme
  })));
});
Textarea.displayName = 'Textarea';
export default Textarea;